import { useEffect, useState } from "react"

function Cookie() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const cookieAccepted = document.cookie.includes('cookieAccepted=true');
        setIsVisible(!cookieAccepted);
    }, []);

    const acceptCookies = () => {
        document.cookie = 'cookieAccepted=true; max-age=2592000'; // 30 days
        setIsVisible(false);
    };

    return (
        isVisible && (
            <div className="fixed-bottom bg-light p-3 text-center text-dark" style={{zIndex: 1000}}>
                This website uses cookies to ensure you get the best experience. No personal data is saved.
                <button className="btn btn-primary btn-sm ms-2" onClick={acceptCookies}>Accept</button>
            </div>
        )
    );
}

export default Cookie;